const template = `
	<div class="tab-links">
		<span v-if="!links || !links.length" class="placeholder-btn">&nbsp;</span>
		<template v-for="link in links">
			<app-link
				v-if="type === 'appLink'"
				:to="link.url"
				:class="link.active ? 'active' : ''"
				@click="onClick($event, link)"
			>{{ link.text }}</app-link><a
				v-else-if="type === 'link'"
				:href="link.url"
				:class="link.active ? 'active' : ''"
				@click="onClick($event, link)"
			>{{ link.text }}</a><span
				v-else-if="type === 'btn'"
				:class="link.active ? 'active' : ''"
				@click="onClick($event, link)"
			>{{ link.text }}</span><router-link
				v-else
				:to="link.url"
				:class="link.active ? 'active' : ''"
				@click="onClick($event, link)"
			>{{ link.text }}</router-link>
		</template>
	</div>
`;

export default {
	template,
	props: ['links', 'type'],
	methods: {
		onClick(e, link) {
			link.onClick && link.onClick(e);
		}
	}
};